import {
	BillingDefermentStateEnum,
	PaymentAvailabilityEnum,
	PaymentAvailabilityReasonEnum,
} from '.spec/self-care/tsTypes';

export const isBillingDeferred = (billing) => Boolean(billing.additionalInfoDeferment.deferment);

export const isBillingPayable = (billing) =>
	isBillingDeferred(billing)
		? billing.additionalInfoDeferment.state !== BillingDefermentStateEnum.SUCCESS
		: billing.paymentAvailability.availability === PaymentAvailabilityEnum.AVAILABLE;

export const isBillingSplittable = (
	billing,
	isInstallmentsEnabled,
	isEligibleForInstallmentsApplying
) =>
	!!billing.additionalInfoInstallments?.canApplyForInstallments &&
	isInstallmentsEnabled &&
	isEligibleForInstallmentsApplying;

export const isBillingCurrent = (billing) =>
	billing.paymentAvailability.availability === PaymentAvailabilityEnum.NOT_AVAILABLE &&
	billing.paymentAvailability.reasons?.includes(PaymentAvailabilityReasonEnum.BILLING_NOT_CLOSED);
